import React, { useState } from "react";

const EpSurseoirModal = ({ inscription, onConfirm, onCancel, isSaving }) => {
  const [comment, setComment] = useState("");

  const canConfirm = comment.trim().length > 0;

  return (
    <div
      className="position-fixed d-flex align-items-center justify-content-center"
      style={{
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.5)",
        zIndex: 10001,
      }}
    >
      <div
        className="bg-white rounded shadow p-4"
        style={{ maxWidth: 500, width: "90%" }}
      >
        <h5
          className="mb-1"
          style={{ fontSize: 18, color: "#1e293b", fontWeight: 700 }}
        >
          <i
            className="fa fa-pause-circle mr-2"
            style={{ color: "#f59e0b" }}
          />
          À surseoir
        </h5>
        <p style={{ fontSize: 13, color: "#64748b", marginBottom: 16 }}>
          {inscription.userRecipient?.fullname || "Allocataire"}
        </p>

        <div
          className="p-3 rounded mb-4"
          style={{
            background: "#fefce8",
            border: "1px solid #fde68a",
            fontSize: 13,
            color: "#92400e",
          }}
        >
          <i className="fa fa-exclamation-triangle mr-2" />
          Un commentaire est obligatoire pour justifier le surseoir.
        </div>

        <label
          style={{ fontSize: 13, fontWeight: 600, color: "#1e293b" }}
          className="mb-1 d-block"
        >
          Commentaire du directeur
        </label>
        <textarea
          className="form-control mb-4"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Motif du surseoir..."
          rows={4}
          autoFocus
          style={{
            borderRadius: 8,
            border: comment.trim()
              ? "1px solid #e2e8f0"
              : "1px solid #fca5a5",
            fontSize: 13,
            resize: "vertical",
          }}
        />

        <div className="d-flex justify-content-end" style={{ gap: 10 }}>
          <button
            className="btn btn-secondary"
            onClick={onCancel}
            disabled={isSaving}
          >
            Annuler
          </button>
          <button
            className="btn"
            onClick={() => onConfirm(comment.trim())}
            disabled={!canConfirm || isSaving}
            style={{
              background: canConfirm
                ? "linear-gradient(135deg, #f59e0b, #d97706)"
                : "#e2e8f0",
              color: canConfirm ? "#fff" : "#94a3b8",
              border: "none",
              borderRadius: 8,
              fontWeight: 700,
            }}
          >
            {isSaving ? (
              <i className="fa fa-spinner fa-spin mr-2" />
            ) : (
              <i className="fa fa-pause-circle mr-2" />
            )}
            Confirmer le surseoir
          </button>
        </div>
      </div>
    </div>
  );
};

export default EpSurseoirModal;
